/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step2_RuleInputs */

const en_dr_step2_rule = /** @type {(inputs: Dr_Step2_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personas are required before any idea card`)
};

const id_dr_step2_rule = /** @type {(inputs: Dr_Step2_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persona wajib ada sebelum kartu ide mana pun`)
};

/**
* | output |
* | --- |
* | "Personas are required before any idea card" |
*
* @param {Dr_Step2_RuleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step2_rule = /** @type {((inputs?: Dr_Step2_RuleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step2_RuleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step2_rule(inputs)
	return en_dr_step2_rule(inputs)
});